module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAGBAMAAADj6an2AAAALVBMVEUAAACampqqqqqZmZmbm5ubm5uampqZmZmampqZmZmampqZmZmampqampqZmZlCter+AAAADnRSTlMAYgT0XD0n4d6tqaCYR8zRUMoAAAAtSURBVAjXY2DQbmVgYGCa9ziAgUHr3TtTBoZz7949TmCoe/funQNDoqCIrwIA16MNJ7LtV+cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_up.png
// module id = SxW2
// module chunks = 1